export function getValidatedSearchFormState() {
  let storedState = JSON.parse(localStorage.getItem('search_form_state') || '{}');
  if (storedState.dateRange?.start && storedState.dateRange?.end) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const savedStartDate = new Date(storedState.dateRange.start);
    const savedEndDate = new Date(storedState.dateRange.end);
    
    if (savedEndDate < today || savedStartDate < today) {
      // Clear the expired data
      localStorage.removeItem('search_form_state');
      storedState = {};
    }
  }
  return storedState;
}